function getRecipeId(recipe) {
    if (!recipe) return undefined;
    return recipe.id || recipe.objectID || recipe._id || undefined;
}

export default getRecipeId;